import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[currencyMask]',
  host: {
    '(keydown)': 'currency($event)',
    '(focus)': 'setCurrency($event)',
    '(keyup)': 'formatCurrency($event)',
  },
})
export class CurrencyMaskDirective {
  constructor(private readonly el: ElementRef) {}
  // array of valids keys  for currency input
  private validKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Del',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    ',',
  ];

  currency(event: KeyboardEvent) {
    if (!this.validKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  formatCurrency(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only valid characters
    if (!this.validKeys.includes(event.key)) {
      return;
    }

    // Handle decimal point
    if (event.key === ',' && value.indexOf(',') !== -1) {
      return;
    }

    // Split the value into integer and decimal parts
    let [integerPart, decimalPart] = value.split(',');

    // Format the integer part
    integerPart = integerPart
      .replace(/[^\d]/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Limit the decimal part to 3 digits
    // if (decimalPart) {
    //   decimalPart = decimalPart.substring(0, 3);
    // }

    // Combine the integer and decimal parts
    const formattedValue = decimalPart
      ? `${integerPart},${decimalPart}`
      : integerPart;

    input.value = formattedValue;
    this.el.nativeElement.value = formattedValue;

    event.target.dispatchEvent(new Event('input'));
  }
  // formatCurrency(event: KeyboardEvent) {
  //   const input = event.target as HTMLInputElement;
  //   let value = input.value;

  //   // Allow only valid characters
  //   if (!this.validKeys.includes(event.key)) {
  //     return;
  //   }

  //   // Handle decimal point
  //   if (event.key === '.' && value.indexOf('.') !== -1) {
  //     return;
  //   }

  //   // Format the value
  //   const formattedValue = value
  //     .replace(/[^\d.]/g, '') // Remove all characters except digits and the decimal point
  //     .replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Insert commas every 3 digits
  //     .replace(/\.(\d{2})\d*$/, '.$1'); // Limit to 2 decimal places

  //   // If the decimal point is the last character, add a trailing zero
  //   if (formattedValue.endsWith('.')) {
  //     formattedValue += '0';
  //   }

  //   input.value = formattedValue;
  //   this.el.nativeElement.value = formattedValue;

  //   event.target.dispatchEvent(new Event('input'));
  // }
  setCurrency(event) {
    let input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only valid characters
    if (!this.validKeys.includes(event.key)) {
      return;
    }
    // Handle decimal point
    if (event.key === ',' && value.indexOf(',') !== -1) {
      return;
    }
    // Split the value into integer and decimal parts
    let [integerPart, decimalPart] = value.split(',');
    // Format the integer part
    integerPart = integerPart
      .replace(/[^\d]/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Limit the decimal part to 3 digits
    // if (decimalPart) {
    //   decimalPart = decimalPart.substring(0, 3);
    // }

    // Combine the integer and decimal parts
    const formattedValue = decimalPart
      ? `${integerPart},${decimalPart}`
      : integerPart;

    console.log(value);

    input.value = input.value == '' ? '0.00' : input.value;
    event.target.dispatchEvent(new Event('input'));
  }
  // formatCurrency(event: KeyboardEvent) {
  //   // const regex = /(\d)(?=(\d{3})*(?!\d))?/g;
  //   // const replacement = '$1,';
  //   let value = (event.target as HTMLInputElement).value;
  //   let valueArr = value.split('').reverse();
  //   let copyValue = [...valueArr];
  //   let countComma = 4;
  //   let havePoint = true;
  //   for (let [index, character] of copyValue.entries()) {
  //     if (character != ',') {
  //       countComma -= 1;
  //     }
  //     if (character == '.') {
  //       havePoint = false;
  //     }
  //     if (valueArr[valueArr.length - 1] == '0') {
  //       valueArr.splice(valueArr.length - 1, 1);
  //     }
  //     if (
  //       index != 0 &&
  //       // index % 3 == 0 &&
  //       countComma == 0 &&
  //       character != '.' &&
  //       character != ',' && // &&
  //       // index != valueArr.length - 1
  //       !havePoint
  //     ) {
  //       countComma = 4;
  //       valueArr.splice(index, 0, ',');
  //     }
  //   }
  //   console.log(valueArr);
  //   console.log(valueArr.reverse().join(''));
  //   this.el.nativeElement.value = value;
  //   event.target.dispatchEvent(new Event('input'));
  // }
}
